import React, { Component } from 'react';
import { List, Flex, Toast } from 'antd-mobile';
import F2 from '@antv/f2/lib/index';
import { ROOT_PATH } from '../../config';
import df from 'dateformat';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';

import { dateToWeek } from '../../utils/weekToDate';
import EmptyReport from '../../components/EmptyReport.js';
import RangeDatePicker from '../../components/RangeDatePicker';
const today = new Date();
/*let Shape = F2.Shape;
let Util = F2.Util;*/
let loading = 0;
let width = document.documentElement.clientWidth;
let height = 360;
let firstDay = new Date(new Date().setDate(1));
class LiveStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'week',
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      startWeek: dateToWeek(firstDay),
      endWeek: dateToWeek(new Date()),
      startDate: firstDay,
      endDate: new Date(),
      data: [],
      data3None: true,
      data3: [
        {},
        {}
        //第一个为百分比 ，单位：%
        /*   {
             'wk13to16': 0, //13-16周
             'wk17to20': 0, //17-20周
             'wk1to4': 0,//1-4周
             'wk20more': 93,//20周以上
             'wk5to8': 0,//5-8周
             'wk9to12': 6//9-12周
           },
   //    第二个为损失数，单位 头
           {
             'wk13to16': 0,
             'wk17to20': 0,
             'wk1to4': 0,
             'wk20more': 67,
             'wk5to8': 0,
             'wk9to12': 5
           }*/
      ], //损失分周龄
      data1: [], // 损失头数
      data4: [],
      data2: [
        /*        {
                  'descEng': 'จับปกติ',
                  'descLoc': '挑选',
                  'qtyLoc2': 6,
                  'qtyLoc3': 0,
                  'qtyLoc4': 0,
                  'rate': 0,
                  'reasonCode': '00'
                }*/
      ] // 损失原因
    };
  }
  // 损失头数
  getReport01 = (data1) => {
    // const {data1} = this.state;
    if (data1.length < 1) {
      return;
    }
    let chart = this.chart1;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart2',
        pixelRatio: window.devicePixelRatio
      });
    }
    this.chart1 = chart;
    chart.source(data1, {
      sales: {
        tickCount: 5
      }
    });

    chart.axis('qty', {
      line: {
        stroke: '#EEE'
      }
    });
    chart.tooltip({
      showItemMarker: false,
      onShow: function onShow(ev) {
        var items = ev.items;
        items[0].name = null;
        items[0].name = items[0].title;
        items[0].value = items[0].value + '头';
      }
    });

    data1.forEach((item) => {
      chart.guide().text({
        position: [item.descLoc, item.qty],
        content: item.qty,
        offsetY: -12
      });
    });
    chart
      .interval()
      .position('descLoc*qty')
      .color('#1890FF')
      .size(20);
    chart.render();
  };

  // 损失原因
  getReport02 = (data2) => {
    // const {data2} = this.state;
    if (data2.length < 1) {
      return;
    }
    let data = [];
    let locs = ['Loc2', 'Loc3', 'Loc4'];
    let obj = {
      Loc2: '分娩舍',
      Loc3: '保育舍',
      Loc4: '育成舍'
    };
    let originData = [];
    data2.forEach((item) => {
      originData.push(item.descLoc);
      locs.forEach((loc) => {
        data.push({
          xName: item.descLoc,
          groupName: loc,
          yName: item['qty' + loc]
        });
      });
    });
    let chart = this.chart2;

    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart1',
        pixelRatio: window.devicePixelRatio,
        padding: ['auto', 'auto', '50', 'auto'],
        plugins: [require('@antv/f2/lib/plugin/scroll-bar'), require('@antv/f2/lib/interaction/pan')]
      });
    }
    this.chart2 = chart;
    let arr1 = [];
    data.forEach((item) => {
      arr1.push(item.yName);
    });
    let max = Math.max.apply(null, arr1);
    let min = Math.min.apply(null, arr1);
    chart.source(data, {
      xName: {
        type: 'cat',
        values: originData.slice(0, 7)
      },
      yName: {
        tickCount: 5,
        min,
        max
      }
    });
    chart.axis('yName', {
      line: {
        stroke: '#EEE'
      }
    });
    chart.axis('xName', {
      grid: null,
      offsetY: 10,
      label: (text) => {
        const cfg = {
          textAlign: 'center'
        };
        //  超过7个字分两行
        if (text.length > 5) {
          text = text.substring(0, 5) + '\n' + text.substring(5, 10) + '\n' + text.substring(10);
        }
        cfg.text = text; // cfg.text 支持文本格式化处理
        return cfg;
      }
    });
    chart.legend('groupName', {
      align: 'center',
      itemGap: 35,
      marker: {
        radius: 5
      },
      valueStyle: {
        fontSize: 14
      },
      itemFormatter(val) {
        return obj[val]; // val 为每个图例项的文本值
      }
    });
    chart.tooltip({
      // custom: true, // 自定义 tooltip 内容框
      offsetY: 15,
      onShow: function onShow(ev) {
        var items = ev.items;
        items.forEach((item) => {
          item.name = obj[item.name];
          item.value = item.value + '头';
        });
      },
      onHide: function onHide() {
        // var legend = chart.get('legendController').legends.top[0];
        // legend.setItems(chart.getLegendItems().country);
      }
    });
    chart
      .interval()
      .position('xName*yName')
      .color('groupName', ['#FE5578', '#5781ED', '#FFD400'])
      .adjust('stack')
      .shape('text')
      .size(20);

    // 定义进度条
    chart.scrollBar({
      mode: 'x',
      xStyle: {
        offsetY: 0
      }
    });

    chart.render();

    chart.interaction('pan', {
      mode: 'x'
    });
    console.log('原因渲染');
  };

  // 三段损失分周领
  getReport03 = (data3) => {
    // let {data3} = this.state;
    if (typeof data3[0].wk1to4 === 'undefined') {
      return;
    }
    let arr = [];
    let obj = {
      wk1to4: '1~4周',
      wk5to8: '5~8周',
      wk9to12: '9~12周',
      wk13to16: '13~16周',
      wk17to20: '17~20周',
      wk20more: '20周以上'
    };
    Object.keys(obj).forEach((atr) => {
      arr.push({
        amount: data3[1][atr],
        ratio: data3[0][atr],
        memo: obj[atr],
        const: 'birth'
      });
    });
    let chart = this.chart3;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart3',
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        padding: [80, 'auto', 'auto', 'auto'],
        pixelRatio: window.devicePixelRatio
      });
    }
    this.chart3 = chart;
    chart.source(arr);
    chart.coord('polar', {
      transposed: true,
      innerRadius: 0.4,
      radius: 0.55
    });
    chart.axis(false);
    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 70,
      marker: {
        radius: 5
      },
      titleStyle: {
        fontSize: 14
      }
    });
    chart.tooltip(false);
    chart.guide().html({
      position: ['50%', '50%'],
      html: '<div style="width: 100px;height: 20px;text-align: center;line-height: 20px;" id="textContent"></div>'
    });
    // 配置文本饼图
    chart.pieLabel({
      lineHeight: 45,
      label1OffsetY: -3, // label1 与连接线在垂直方向的偏移量
      label2OffsetY: 2,
      sidePadding: 20,
      activeShape: true, // 鼠标点击会不会凸起
      label1: function label1(data) {
        return {
          text: data.memo,
          fill: '#808080'
        };
      },
      label2: function label2(data) {
        return {
          fill: '#000',
          text: data.amount + '头 (' + data.ratio.toFixed(0) + '% )',
          fontWeight: 500,
          fontSize: 10
        };
      }
    });
    chart
      .interval()
      .position('const*ratio')
      .color('memo', ['#1890FF', '#0DAFCF', '#B2CF23', '#F26F12', '#FE5578', '#AD51DB'])
      .adjust('stack');
    chart.render();

    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.2, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();
    console.log('饼图渲染');
  };

  //  损失分周龄
  getData3 = (a, b) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/lossWeekAgeGraph`,
        qs.stringify(
          {
            startDate: a,
            endDate: b,
            gd_type: 'D001001',
            gd_code: ['4001', '4002']
          },
          {
            indices: false
          }
        ),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        loading++;
        if (!(res.data instanceof Array)) {
          return;
        }
        this.setState({
          data3: res.data,
          data3None: typeof res.data[0].wk1to4 === 'number'
        });
        res.data instanceof Array && res.data.length > 0 && this.getReport03(res.data);
      })
      .catch((err) => {
        return err;
      });
  };
  // 损失原因
  getData2 = (a, b) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/loc2LossGraph`,
        qs.stringify({
          startDate: a,
          endDate: b,
          dateToday: b,
          gd_type: 'D001001',
          gd_code: '2002'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        loading++;
        this.setState({
          data2: res.data
        });
        if (res.data instanceof Array && res.data.length > 0) {
          this.getReport02(res.data);
        }
      })
      .catch((err) => {
        return err;
      });
  };
  // 三段损失分析表格
  getData4 = (a, b) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/loc2Detail`,
        qs.stringify({
          startDate: a,
          endDate: b,
          gd_type: 'D001001',
          gd_code: '3001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        loading++;
        this.setState({
          data4: res.data
        });
      })
      .catch((err) => {
        return err;
      });
  };
  // 损失头数
  getData1 = (a, b) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/loc2Graph`,
        qs.stringify({
          startDate: a,
          endDate: b,
          dateToday: b,
          gd_type: 'D001001',
          gd_code: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        loading++;
        this.setState({
          data1: res.data
        });

        res.data instanceof Array && res.data.length > 0 && this.getReport01(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  doSearch = (a, b) => {
    Toast.loading('加载中', 0);
    loading = 0;
    this.getData1(a, b);
    this.getData2(a, b);
    this.getData3(a, b);
    this.getData4(a, b);
  };
  componentDidUpdate() {
    loading === 4 && Toast.hide();
  }

  componentDidMount() {
    window._czc.push(['_trackEvent', '进入三段损失分析页面']);
    const { startDate, endDate } = this.state;
    this.doSearch(df(startDate, 'yyyy-mm-dd'), df(endDate, 'yyyy-mm-dd'));
  }

  render() {
    const { data4 } = this.state;
    return (
      <React.Fragment>
        <List.Item
          arrow="horizontal"
          className="span-4"
          extra={`${df(this.state.startDate, 'yyyy-mm-dd')} 至 ${df(this.state.endDate, 'yyyy-mm-dd')}`}
          onClick={() => {
            this.setState({
              visible: true
            });
          }}
        >
          选择日期
        </List.Item>

        <List renderHeader={() => ''}>
          <span className="title">三段损失头数</span>
          <div style={{ display: this.state.data1.length > 0 ? 'block' : 'none' }}>
            <canvas height={height} id="myChart2" width={width} />
          </div>
          {this.state.data1.length <= 0 && <EmptyReport height={310} width={width} />}

          <List.Item>
            {data4[9] && (
              <div className="table-container">
                <Flex align="center" justify="between">
                  <Flex.Item align="center" className="table">
                    <span>{data4[0].descLoc}</span>
                    <span>{data4[0].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[1].descLoc}</span>
                    <span>{data4[1].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[2].descLoc}</span>
                    <span>{data4[2].val}</span>
                  </Flex.Item>
                </Flex>
                <Flex align="center" justify="around" wrap="wrap">
                  <Flex.Item align="center" className="table">
                    <span>{data4[3].descLoc}</span>
                    <span>{data4[3].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[4].descLoc}</span>
                    <span>{data4[4].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[5].descLoc}</span>
                    <span>{data4[5].val}</span>
                  </Flex.Item>
                </Flex>
                <Flex align="center" justify="around" wrap="wrap">
                  <Flex.Item align="center" className="table">
                    <span>{data4[6].descLoc}</span>
                    <span>{data4[6].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[7].descLoc}</span>
                    <span>{data4[7].val}</span>
                  </Flex.Item>
                  <Flex.Item align="center" className="table">
                    <span>{data4[8].descLoc}</span>
                    <span>{data4[8].val}</span>
                  </Flex.Item>
                </Flex>
                <Flex align="center" justify="around" wrap="wrap">
                  <Flex.Item align="center" className="table" />
                  <Flex.Item align="center" className="table" />
                  <Flex.Item align="center" className="table">
                    <span>{data4[9].descLoc}</span>
                    <span>{data4[9].val}</span>
                  </Flex.Item>
                </Flex>
              </div>
            )}
          </List.Item>
        </List>

        <List renderHeader={() => ''}>
          <span className="title">三段损失原因</span>
          <div style={{ display: this.state.data2.length > 0 ? 'block' : 'none' }}>
            <canvas height={height} id="myChart1" width={width} />
          </div>
          {this.state.data2.length <= 0 && <EmptyReport height={280} width={width} />}
        </List>

        <List renderFooter={() => ''} renderHeader={() => ''}>
          <span className="title">三段损失分周龄 </span>
          <div style={{ display: this.state.data3None ? 'block' : 'none' }}>
            <canvas height={height} id="myChart3" width={width} />
          </div>
          {!this.state.data3None && <EmptyReport height={280} width={width} />}
        </List>

        <RangeDatePicker
          defaultDate={this.state.startDate}
          defaultValue={[this.state.startDate, this.state.endDate]}
          onCancel={() => {
            this.setState({ visible: false });
          }}
          onConfirm={(start, end, type) => {
            let startDate = type === 'week' ? start.startDate : start;
            let endDate = type === 'week' ? end.endDate : end;
            this.setState({
              mode: type,
              visible: false,
              startDate,
              endDate
            });
            this.doSearch(df(startDate, 'yyyy-mm-dd'), df(endDate, 'yyyy-mm-dd'));
          }}
          visible={this.state.visible}
        />

        {/*按照周龄来查询*/}
        {/* <DatePicker
            defaultValues={[this.state.startDate, this.state.endDate]}
            mode={['week', 'month']}
            onCancel={() => {
            this.setState({ visible: false })
          }}
            onConfirm={(start, end, type) => {
            let startDate = type === 'week' ? start.startDate : start
            let endDate = type === 'week' ? end.endDate : end
            this.setState({
              mode: type,
              visible: false,
              startDate,
              endDate
            })
            this.doSearch(
              df(startDate, 'yyyy-mm-dd'),
              df(endDate, 'yyyy-mm-dd')
            )
          }}
            visible={this.state.visible}
        />*/}
      </React.Fragment>
    );
  }
}

export default LiveStock;
